import { checkThenGetImageUrl } from '@tools/media-image';

/**
 * @description Workaround for profile picture fallback through svg
 */
export const profilePictureFallback = () => {
  document.querySelectorAll('.profile-picture-svg-image').forEach(async (element) => {
    const uuid = element.getAttribute('data-uuid');
    const newUrl = await checkThenGetImageUrl(uuid, 'webp', 90, null, [ 90, 105 ], [ 1, 1 ]);
    element.setAttribute('xlink:href', newUrl);
  });
};
